import oliver from "../oliver.png";

function OliverIcon() {
	return <img src={oliver} width={20} />;
}

export default OliverIcon;
